class Controller {
  constructor(
    $injector,
    Events,
    $stateParams,
    ContractorsTransforms,
    Sections
  ) {
    "ngInject";
    this.addItemEvent = Events.getAddEvent("contractors");
    this.filterEvent = Events.getFilterEvent("contractors");
    this.paginateEvent = Events.getPaginateEvent("contractors");
    this.ResetFields = $injector.get("ResetFields");
    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.filters = ContractorsTransforms.filters;
    this.sections = Sections.fleetSections;
  }

  /**
   * @param {{ owner: Object; owner_name: Object; owner_phone_data: String; email?: String; }} model
   */
  addItemCustomizeOptions(model) {
    const { owner_name: ownerName, owner_phone_data: phoneData, email } = model;
    model.owner = {
      name_i18n: ownerName,
      phone_data: phoneData,
      email,
    };
    delete model.owner_name;
    delete model.owner_phone_data;
    delete model.email;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/contractors/contractors.controller.js